import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ArrowRight from "../../../../assets/images/ArrowRight.svg";
import CartIcon from "../../../../assets/images/Cart.svg";
import { calculateTotalBcrsDeposit } from "../../../../common/helpers/bcrsHelper";
import { displayCentsWithDollarSign } from "../../../../common/helpers/stringUtils";
import { useItemSubtotal } from "../../../../common/hooks/useItemSubtotal";
import CartBadge from "../../../../components/CartBadge/CartBadge";
import { Image } from "../../../../components/elements";
import { useCartContext } from "../../../../contexts/CartServiceContext/CartServiceContext";
import { useConfigContext } from "../../../../contexts/ConfigContext/ConfigContext";
import { IStallMode } from "../../../../contexts/ConfigContext/types";
import { PATH } from "../../../../router/path";
import "./GoToCartButton.scss";
import "./GoToCartButton_flint.scss";
import "./GoToCartButton_kokoro.scss";
import "./GoToCartButton_pdd.scss";
import "./GoToCartButton_shabuDays.scss";
import "./GoToCartButton_torikizoku.scss";
import "./GoToCartButton_wang.scss";

export const GoToCartButton: React.FC = () => {
	const { t } = useTranslation();
	const { state: cart } = useCartContext((state) => state.cart);
	const { state: bcrs_deposit_rate } = useConfigContext((state) => state.config.bcrs_deposit_rate);
	const { state: stallMode } = useConfigContext((state) => state.config.stall.mode);
	const navigate = useNavigate();
	const subtotal = useItemSubtotal(cart);

	// Calculate total BCRS deposit amount using helper
	const bcrsDepositAmount = useMemo(() => {
		return calculateTotalBcrsDeposit(cart || [], bcrs_deposit_rate);
	}, [cart, bcrs_deposit_rate]);

	// Calculate total quantity for CartBadge
	const totalQuantity = useMemo(
		() => cart?.reduce((sum, item) => sum + item.quantity, 0) || 0,
		[cart]
	);

	const handleClickGotoCart = useCallback(() => {
		navigate(PATH.CART);
	}, [navigate]);

	return (
		<button className="GoToCartButton" onClick={handleClickGotoCart}>
			<div className="CartInfoWrapper">
				<CartBadge
					totalQuantity={totalQuantity}
					className="CartIconWrapper"
					data-testid="cart-quantity-badge"
				>
					<Image src={CartIcon} alt="CartIcon" className="CartIcon" />
				</CartBadge>
				<div className="Subtotal">{displayCentsWithDollarSign(subtotal + bcrsDepositAmount)}</div>
			</div>
			<div className="GoToCartButtonLabel">
				{t(
					stallMode === IStallMode.TORIKIZOKU
						? "productListPage.gotoCartBtn.torikizoku"
						: "productListPage.gotoCartBtn"
				)}
				<Image src={ArrowRight} alt="ArrowRight" className="ArrowRight" />
			</div>
		</button>
	);
};
